import { z } from 'zod';

export enum ContentAssetKeys {
    CartDeliveryPopup = 'CART-DELIVERY-POPUP',
    NotifyMeHeaderText = 'notifyme-headertext',
    NotifyMeChartProtectText = 'notifyme-charteprotecttext',
    NotifyMeConfirmationText = 'notifyme-confirmation-text',
    PriceRegulationLegalMentions = 'more-informations-modal',
    DTSLegalMentions = 'dts-cnc-legal-mentions',
    VATLegalMentions = 'vat-legal-mention-plp',
    PaymentReinsurance = 'payment-reinsurance',
}

const operators = z.union([
    z.object({
        name: z.literal('setText'),
        value: z.string(),
    }),
    z.object({
        name: z.literal('setAttribute'),
        value: z.object({ name: z.string(), value: z.string() }),
    }),
    z.object({
        name: z.literal('removeAttribute'),
        value: z.string(),
    }),
    z.object({
        name: z.literal('addClass'),
        value: z.string(),
    }),
    z.object({
        name: z.literal('removeClass'),
        value: z.string(),
    }),
    z.object({
        name: z.literal('removeSelf'),
    }),
    z.object({
        name: z.literal('getText'),
    }),
]);

const transformer = z.object({
    selectors: z.array(
        z.object({
            name: z.string(),
            operators: z.array(operators),
        }),
    ),
});

export const ContentAssetDTO = z.object({
    'content-assets': z.record(z.nativeEnum(ContentAssetKeys), transformer),
});

export type ContentAssetDTO = z.infer<typeof ContentAssetDTO>;
export type ContentAssetOperators = z.infer<typeof operators>;
export type ContentAssetTransformer = z.infer<typeof transformer>;
